var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Lamp = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 736 1024", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M709.18 229.52a368.27 368.27 0 0 0-679.95-5.47A368.34 368.34 0 0 0 191.39 690.9a32 32 0 0 1 16.61 28V864a32 32 0 0 0 32 32h256a32 32 0 0 0 0-64H272V718.94a96 96 0 0 0-49.85-84.17A304 304 0 0 1 370.51 64c81.89.66 158.33 33.15 215.24 91.49S673.33 291.21 672 373.2a303.93 303.93 0 0 1-158 261.5 96.1 96.1 0 0 0-50 84.24V768a32 32 0 0 0 64 0v-49.06a32.14 32.14 0 0 1 16.77-28.13 368.74 368.74 0 0 0 164.41-461.29zM496 960H240a32 32 0 0 0 0 64h256a32 32 0 0 0 0-64z" }),
            React.createElement("path", { className: "cls-1", d: "M576 368a32 32 0 0 0 64 0A272 272 0 0 0 368 96a32 32 0 0 0 0 64c114.69 0 208 93.31 208 208z" }))))); };
export default Lamp;
//# sourceMappingURL=Lamp.js.map